import { CREATE_APP_AORDER_EPOSIT_ADDRESS } from "@/config";

export const app_order_deposit_address = {
  response: `{
  'code': 10000,
  'msg': 'success',
  'data': {
    'address': '0x9aBDDCE1EE18D1857C0653EB4a3Fa9d9E0dcd584',
    'amount': '0.008552856654122477',
    'memo': '',
    'checkoutUrl': 'https://i.ccpayment.com/xxx',
    'confirmsNeeded': 50
  }
}`,
  go: {
    http_ex_code: `package main

import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
)

func main() {

    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"

    // With request params

    path := "${CREATE_APP_AORDER_EPOSIT_ADDRESS}"
    args := []byte(${'`{"coinId": 1280,"price": "1","orderId": "testorderid1111","chain": "POLYGON"}`'})

    //sign
    timestamp := time.Now().Unix()

    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }

    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])

    fmt.Printf("Sign: %s\n", sign)

    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))

    resp, _ := client.Do(request)

    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s\n", respBytes)
}

`,
    example_code: ``,
    example_code2: ``,
  },
  java: {
    http_ex_code: `package com.CCPayment.apis;

import java.nio.charset.StandardCharsets;
import java.security.InvalidKeyException;
import java.security.NoSuchAlgorithmException;
import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;

import com.fasterxml.jackson.databind.ObjectMapper;
import com.fasterxml.jackson.databind.SerializationFeature;
import org.apache.http.HttpResponse;
import org.apache.http.client.HttpClient;
import org.apache.http.client.methods.HttpPost;
import org.apache.http.entity.ByteArrayEntity;
import org.apache.http.impl.client.HttpClientBuilder;
import java.io.BufferedReader;
import java.io.IOException;
import java.io.InputStreamReader;
import java.util.Date;
import java.util.HashMap;
import java.util.Map;

public class paymentApi {
public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
  String appId = "*** your appId ***";
  String appSecret = "*** your appSecret ***";
  // With request params
  String path = "${CREATE_APP_AORDER_EPOSIT_ADDRESS}";

  // params
  Map<String, Object> map = new HashMap<>();
  map.put("coinId", 1280);
  map.put("price", "1");
  map.put("orderId", "testorderid1111");
  map.put("chain", "POLYGON");

  ObjectMapper mapper = new ObjectMapper();
  mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
  String inputString = mapper.writeValueAsString(map);

  byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
  // Sign
  long timestamp = new Date().getTime() / 1000L;
  String signText = appId + timestamp;
  if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
  }
  Mac sha256Hmac = Mac.getInstance("HmacSHA256");
  SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
  sha256Hmac.init(secretKey);
  byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
  String sign = byteArrayToHexString(signBytes);

  // Making API call
  HttpClient client = HttpClientBuilder.create().build();
  HttpPost request = new HttpPost(path);
  request.setHeader("Appid", appId);
  request.setHeader("Sign", sign);
  request.setHeader("Timestamp", String.valueOf(timestamp));
  request.setEntity(new ByteArrayEntity(requestBody));
  HttpResponse response = client.execute(request);
  BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
  StringBuilder responseText = new StringBuilder();
  String line;
  while ((line = reader.readLine()) != null) {
    responseText.append(line);
  }
  reader.close();

  // result
  System.out.println("Resp: " + responseText);
}

private static String byteArrayToHexString(byte[] bytes) {
  StringBuilder hs = new StringBuilder();
  String tempStr;
  for (int index = 0; bytes != null && index < bytes.length; index++) {
    tempStr = Integer.toHexString(bytes[index] & 0XFF);
    if (tempStr.length() == 1)
        hs.append('0');
    hs.append(tempStr);
  }
  return hs.toString().toLowerCase();
}
}`,
    example_code: ``,
    example_code2: ``,
  },
  python: {
    http_ex_code: `# Python 3.9
import json
import time
import hmac
import hashlib
import binascii
import requests

app_id = "*** your app_id ***"
app_secret = "*** your app_secret ***"
url = "${CREATE_APP_AORDER_EPOSIT_ADDRESS}"
content = {
  "coinId": 1280,
  "price": "1",
  "orderId": str(int(time.time())),
  "chain": "POLYGON",
  # "generateCheckoutURL": True,
  # "product": "test",
  # "fiatId": "1033",
  # "expiredAt": int(time.time()) + 10000,
  # "buyerEmail": "",
  # "returnUrl": "",
}

timestamp = int(time.time())
body = json.dumps(content)
sign_text = f"{app_id}{timestamp}"
if len(body) != 2:
  sign_text = f"{sign_text}{body}"
else:
  body = ""

h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
server_sign = binascii.hexlify(h.digest()).decode('utf-8')

res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
print(res.json())`,
    example_code: ``,
    example_code2: ``,
  },
  javascript: {
    http_ex_code: `const https = require("https");
const crypto = require("crypto");

const appId = "*** your appId ***";
const appSecret = "*** your appSecret ***";

const path = "${CREATE_APP_AORDER_EPOSIT_ADDRESS}";
const args = JSON.stringify({
  "coinId": 1280,
  "price": "1",
  "orderId": "testorderid1111",
  "chain": "POLYGON",
});

const timestamp = Math.floor(Date.now() / 1000);
let signText = appId + timestamp;
if (args.length !== 0) {
  signText += args;
}

const sign = crypto
  .createHmac("sha256", appSecret)
  .update(signText)
  .digest("hex");

const options = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Appid": appId,
    "Sign": sign,
    "Timestamp": timestamp.toString(),
  },
};

const req = https.request(path, options, (res) => {
  let respData = "";

  res.on("data", (chunk) => {
    respData += chunk;
  });

  res.on("end", () => {
    console.log("Response:", respData);
  });
});

req.write(args);
req.end();`,
    example_code: ``,
    example_code2: ``,
  },
  php: {
    http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${CREATE_APP_AORDER_EPOSIT_ADDRESS}";
  $content = [ "coinId"=> 1280,
    "price"=> "1",
    "orderId"=> "testorderid111133",
    "chain"=> "POLYGON"];

  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
  $sign_text = $sign_text . $body;
  } else {
  $body = "";
  }

  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);

  $data = array(
  "headers" => array(
    "Content-Type: application/json;charset=utf-8",
    "Appid: " . $app_id,
    "Sign: " . $server_sign,
    "Timestamp: " . $timestamp
  ),
  "body" => $body
  );

  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

  $response = curl_exec($ch);
  curl_close($ch);

  $result = json_decode($response, true);
  print_r($result);
?>`,
    example_code: ``,
    example_code2: ``,
  },
};
